<template>
  <div class="thirdBarNews" :class="`position-${active}`" ref="newsContainer">
    <div class="pills">
      <img
        class="ellipse"
        v-for="(item, index) in 6"
        :key="index"
        :src="require('@/assets/medicine/pill.png')"
        alt=""
      />

      <img
        class="ellipse2"
        :src="require('@/assets/medicine/group1.png')"
        alt=""
      />
      <img
        class="ellipse3"
        :src="require('@/assets/medicine/group2.png')"
        alt=""
      />
    </div>
    <div class="news">
      <template v-for="(item, index) in list" :key="index">
        <div class="newsBlog">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url },
              })
            "
            class="newsec"
          >
            <div class="image-holder">
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :alt="item.title"
                :thumb="item.image.thumbnail"
              />
            </div>
            <div class="content">
              <h2>{{ item.sub_category.name }}</h2>
              <h1>{{ item.title }}</h1>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </div>
          </router-link>
        </div>
      </template>
    </div>
    <div class="anim" ref="anim"></div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();
    const newsContainer = ref(null);
    const active = ref(1);
    const anim = ref(null);
    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
    };

    const handleScroll = () => {
      const diff =
        newsContainer.value.getBoundingClientRect().top -
        newsContainer.value.offsetHeight;
      console.log(newsContainer.value.offsetHeight);
      // console.log(newsContainer.value.getBoundingClientRect().top / newsContainer.value.offsetHeight);
      if (diff < 0) {
        const size = newsContainer.value.offsetHeight / 5;
        active.value = Math.ceil(Math.abs(diff / size)); /* + 1 */
        console.log(active.value);
        anim.value.style.top =
          newsContainer.value.getBoundingClientRect().bottom -
          newsContainer.value.offsetHeight * 2 +
          "px";
        active.value = active.value >= 6 ? 5 : active.value;
      }
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
      if (window.innerWidth >= 1367) {
        window.addEventListener("scroll", handleScroll);
      }
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
        window.removeEventListener("scroll", handleScroll);
      }
    });

    return {
      isIpad,
      newsContainer,
      handleScroll,
      active,
      ...useFormatter(),
      anim,
    };
  },
};
</script>

<style lang="scss" scoped>
.thirdBarNews {
  background: var(--light);
  width: 100%;
  height: 55vw;
  overflow-y: visible;
  overflow-x: clip;
  position: relative;
  z-index: 2;
  transition: all 0.4s ease;
  .pills {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow-x: clip;
    overflow-y: visible;

    .ellipse {
      position: absolute;
      background: transparent;
      &:nth-child(1) {
        width: 19.115vw;
        height: 19.115vw;
        left: 40.5vw;
        top: 16vw;
        transition: all 1s;
      }
      &:nth-child(2) {
        width: 19.115vw;
        height: 19.115vw;
        left: 0;
        top: 40vw;
        transition: all 1s;
      }
      &:nth-child(3) {
        width: 19.115vw;
        height: 19.115vw;
        top: 41.5vw;
        left: 28.5vw;
        transition: all 1s;
      }
      &:nth-child(4) {
        width: 19.115vw;
        height: 19.115vw;
        top: 28.083vw;
        left: 78.823vw;
        right: 9.115vw;
        transition: all 1s;
      }
      &:nth-child(5) {
        width: 19.115vw;
        height: 19.115vw;
        top: 5vw;
        right: -8vw;
        transition: all 1s;
      }
      &:nth-child(6) {
        width: 7.99vw;
        height: 5.688vw;
        left: 1200vw;
        top: 30vw;
        overflow: hidden;
        transition: all 1s;
      }
    }
    .ellipse2 {
      position: absolute;
      background: transparent;
      &:nth-child(7) {
        width: 10.104vw;
        height: 10.104vw;
        top: 67.031vw;
        right: 0;
        transition: all 1s;
      }
    }
    .ellipse3 {
      position: absolute;
      background: transparent;
      width: 3.177vw;
      height: 3.177vw;
      top: 34.479vw;
      left: -1vw;
      transition: all 1s;
    }
  }

  .news {
    pointer-events: none;
    .newsBlog {
      pointer-events: all;
      cursor: pointer;
      .newsec {
        cursor: pointer;
        width: 21.792vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        .image-holder {
          width: 19.917vw;
          height: 19.917vw;
          background: linear-gradient(180deg, #08455b 0%, #2a8b84 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        cursor: pointer;
          .img {
            width: 18.875vw;
            height: 18.875vw;
            border-radius: 50%;
          }
        }
        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          font-family: "Open Sans", sans-serif;
          h2 {
            font-size: 0.833vw;
            line-height: 1.146vw;
            font-weight: 400;
            color: var(--primary-t-color);
            margin-bottom: 0.121vw;
          }
          h1 {
            font-size: 1.146vw;
            line-height: 1.302vw;
            font-weight: 400;
            color: var(--primary-m-color);
            margin-bottom: 0.221vw;
            font-family: "Alice", serif;
          }
          h3 {
            font-size: 0.781vw;
            line-height: 1.094vw;
            font-weight: 300;
            color: var(--primary-b-color);
            margin-bottom: 0.121vw;
          }
        }
      }
      &:nth-child(1) {
        margin-left: 15.833vw;
        margin-right: 64.375vw;
        transform: translateY(10vw);
        transition: all 1s;
      }
      &:nth-child(2) {
        margin-left: 70.885vw;
        margin-right: 15.052vw;
        transform: translateY(10vw);
        transition: all 1s;
      }
      &:nth-child(3) {
        transform: scale(0);
        margin-left: 43.031vw;
        margin-right: 44.115vw;
        transition: all 1s;
      }
      &:nth-child(4) {
        transform: scale(0);
      }
      &:nth-child(5) {
        // transform: scale(0);
        transform: scale(0) translateY(10vw);
        margin-left: 70vw;
      }
    }
  }
}
.anim {
  position: absolute;
  top: 0;
  width: 100%;
  height: 65vw;
  background: white;
  z-index: -1;
  pointer-events: none;
}
.position-1 {
  opacity: 0;
}
.position-2 {
  background: var(--light);
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  position: relative;
  opacity: 1;
  .pills {
    .ellipse {
      position: absolute;
      background: transparent;
      &:nth-child(1) {
        width: 19.115vw;
        height: 19.115vw;
        left: 40.833vw;
        top: -16vw;
        transform: scale(1) rotate(-120deg);
      }
      &:nth-child(2) {
        width: 19.115vw;
        height: 19.115vw;
        left: 0;
        top: 6vw;
        transform: rotate(-10deg);
      }
      &:nth-child(3) {
        width: 19.115vw;
        height: 19.115vw;
        top: 10vw;
        left: 28.5vw;
        transform: rotate(110deg);
        transition: all 1s;
      }
      &:nth-child(4) {
        width: 19.115vw;
        height: 19.115vw;
        top: 28.083vw;
        left: 78.823vw;
        right: 9.115vw;
        transform: scale(0.9);
        transition: all 1s;
      }
      &:nth-child(5) {
        width: 19.115vw;
        height: 19.115vw;
        top: -20vw;
        right: -8vw;
        transform: scale(0.8) rotate(-70deg);
        transition: all 1s;
      }
      &:nth-child(6) {
        opacity: 0;
        left: 65.6vw;
      }
    }
    .ellipse2 {
      position: absolute;
      background: transparent;
      &:nth-child(7) {
        width: 10.104vw;
        height: 10.104vw;
        top: 67.031vw;
        right: 0;
        transition: all 1s;
      }
    }
    .ellipse3 {
      position: absolute;
      background: transparent;
      width: 3.177vw;
      height: 3.177vw;
      top: 0.479vw;
      left: -1vw;
      transition: all 1s;
    }
  }
  .news {
    .newsBlog {
      opacity: 1;
      &:nth-child(1) {
        transform: scale(1) translateY(-16vw);
        margin-left: 15.833vw;
        margin-right: 64.375vw;
        transition: all 1s;
      }
      &:nth-child(2) {
        transform: scale(0.8) translateY(-43vw);
        margin-left: 70.885vw;
        margin-right: 15.052vw;
        transition: all 1s;
      }
      &:nth-child(3) {
        opacity: 0;
        transition: all 1s;
      }
      &:nth-child(4) {
        opacity: 0;
        transition: all 1s;
      }
      &:nth-child(5) {
        transform: scale(0) translateY(-128vw);
        transition: all 1s;
      }
    }
  }
}
.position-3 {
  background: var(--light);
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  .pills {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow-x: clip;
    overflow-y: visible;

    .ellipse {
      position: absolute;
      background: transparent;
      &:nth-child(1) {
        left: 40.4vw;
        top: -28vw;
        transform: scale(0.6) rotate(110deg);
        transition: all 1s;
      }
      &:nth-child(2) {
        width: 21.115vw;
        height: 21.115vw;
        left: -1.3vw;
        top: -8vw;
        transform: rotate(24deg);
        transition: all 1s;
      }
      &:nth-child(3) {
        top: -6vw;
        left: 28vw;
        transform: rotate(95deg) scale(1);
        transition: all 1s;
      }
      &:nth-child(4) {
        top: -4vw;
        left: 77.823vw;
        transform: scale(0.7) rotate(6deg);
        transition: all 1s;
      }
      &:nth-child(5) {
        width: 19.115vw;
        height: 19.115vw;
        top: -27vw;
        right: -8vw;
        transform: scale(0.6) rotate(-12deg);
        transition: all 1s;
      }
      &:nth-child(6) {
        width: 19.115vw;
        height: 19.115vw;
        left: 65.6vw;
        top: 13vw;
        transition: all 1s;
      }
    }
    .ellipse2 {
      position: absolute;
      background: transparent;
      &:nth-child(7) {
        width: 12.104vw;
        height: 12.104vw;
        top: 8vw;
        right: -4vw;
        transform: rotate(15deg);
        transition: all 1s;
      }
    }
    .ellipse3 {
      position: absolute;
      background: transparent;
      width: 3.177vw;
      height: 3.177vw;
      top: -8vw;
      left: -0.8vw;
      transform: rotate(60deg);
      transition: all 1s;
    }
  }

  .news {
    .newsBlog {
      opacity: 1;
      &:nth-child(1) {
        transform: scale(0.8) translateY(-39.5vw);
        transition: all 1s;
        margin-left: 16.5vw;
      }
      &:nth-child(2) {
        transform: scale(1) translateY(-36vw);
        transition: all 1s;
        margin-left: 70.4vw;
      }
      &:nth-child(3) {
        transform: scale(0.8) translateY(-58vw);
        margin-left: 43.5vw;
        margin-right: 44.115vw;
        transition: all 1s;
      }
      &:nth-child(4) {
        opacity: 1;
        transform: scale(0.6) translateY(-70vw);
        margin-left: -4vw;
        transition: all 1s;
      }
      &:nth-child(5) {
        transform: scale(1) translateY(-65vw);
        transition: all 1s;
        margin-left: 70vw;
      }
    }
  }
}
.position-4 {
  background: var(--light);
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  .pills {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow-x: clip;
    overflow-y: visible;

    .ellipse {
      position: absolute;
      background: transparent;
      &:nth-child(1) {
        left: 40.4vw;
        top: -21.5vw;
        transform: scale(0.5) rotate(120deg);
        transition: all 1s;
      }
      &:nth-child(2) {
        left: 0;
        top: -10vw;
        transform: rotate(24deg) scale(1);
        transition: all 1s;
      }
      &:nth-child(3) {
        width: 19.115vw;
        height: 19.115vw;
        top: -7vw;
        left: 28vw;
        transform: rotate(100deg);
        transition: all 1s;
      }
      &:nth-child(4) {
        top: 5.083vw;
        top: -16vw;
        left: 77.8vw;
        transform: scale(0.8) rotate(60deg);
        transition: all 1s;
      }
      &:nth-child(5) {
        width: 19.115vw;
        height: 19.115vw;
        top: -22vw;
        right: -8vw;
        transform: scale(0.5) rotate(-12deg);
        transition: all 1s;
      }
      &:nth-child(6) {
        width: 19.115vw;
        height: 19.115vw;
        left: 65.6vw;
        top: 25vw;
        transform: scale(0.9) rotate(60deg);
        transition: all 1s;
      }
    }
    .ellipse2 {
      position: absolute;
      background: transparent;
      &:nth-child(7) {
        width: 12.104vw;
        height: 12.104vw;
        top: 14vw;
        right: -4vw;
        transform: rotate(40deg);
        transition: all 1s;
      }
    }
    .ellipse3 {
      position: absolute;
      background: transparent;
      width: 3.7vw;
      height: 3.7vw;
      top: -10vw;
      left: -0.5vw;
      transform: rotate(130deg);
      transition: all 1s;
    }
  }

  .news {
    .newsBlog {
      opacity: 1;
      &:nth-child(1) {
        transform: scale(0.6) translateY(-60vw);
        margin-left: 15.833vw;
        margin-right: 64.375vw;
        transition: all 1s;
      }
      &:nth-child(2) {
        transform: scale(0.8) translateY(-70vw);
        margin-left: 70.4vw;
        margin-right: 15.052vw;
        transition: all 1s;
      }
      &:nth-child(3) {
        display: block;
        transform: scale(1) translateY(-53vw);
        margin-left: 42.5vw;
        margin-right: 44.115vw;
        transition: all 1s;
      }
      &:nth-child(4) {
        display: block;
        transform: scale(0.8) translateY(-60vw);
        margin-left: 3.7vw;
        transition: all 1s;
      }
      &:nth-child(5) {
        display: block;
        transform: scale(0.8) translateY(-102vw);
        margin-left: 68vw;
        transition: all 1s;
      }
    }
  }
}
.position-5 {
  background: var(--light);
  width: 100%;
  transition: all 1s ease;
  overflow-x: clip;
  overflow-y: visible;
  .pills {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow-x: clip;
    overflow-y: visible;

    .ellipse {
      position: absolute;
      background: transparent;
      &:nth-child(1) {
        width: 19.115vw;
        height: 19.115vw;
        left: 40.5vw;
        top: -17vw;
        transform: scale(0.5) rotate(120deg);
        transition: all 1s;
      }
      &:nth-child(2) {
        width: 19.115vw;
        height: 19.115vw;
        left: 0;
        top: -6vw;
        transform: scale(0.9) rotate(-60deg);
        transition: all 1s;
      }
      &:nth-child(3) {
        width: 19.115vw;
        height: 19.115vw;
        top: -3vw;
        left: 27.5vw;
        transform: scale(0.6) rotate(24deg);
        transition: all 1s;
      }
      &:nth-child(4) {
        top: -16vw;
        left: 76.823vw;
        transform: scale(0.8) rotate(6deg);
        transition: all 1s;
      }
      &:nth-child(5) {
        width: 19.115vw;
        height: 19.115vw;
        top: -16vw;
        right: -8vw;
        transform: scale(0.5) rotate(-12deg);
        transition: all 1s;
      }
      &:nth-child(6) {
        width: 19.115vw;
        height: 19.115vw;
        left: 65.6vw;
        top: 23vw;
        transform: scale(1) rotate(90deg);
        transition: all 1s;
      }
    }
    .ellipse2 {
      position: absolute;
      background: transparent;
      &:nth-child(7) {
        width: 12.104vw;
        height: 12.104vw;
        top: 12vw;
        right: -4.3vw;
        transform: rotate(95deg);
        transition: all 1s;
      }
    }
    .ellipse3 {
      position: absolute;
      background: transparent;
      width: 3.177vw;
      height: 3.177vw;
      top: 0.479vw;
      left: -0.5vw;
      transform: rotate(130deg);
      transition: all 1s;
    }
  }

  .news {
    .newsBlog {
      opacity: 1;
      &:nth-child(1) {
        transform: scale(0.6) translateY(-45vw);
        margin-left: 15.833vw;
        margin-right: 64.375vw;
        transition: all 1s;
      }
      &:nth-child(2) {
        transform: scale(0.5) translateY(-100vw);
        margin-left: 68.885vw;
        margin-right: 15.052vw;
        transition: all 1s;
      }
      &:nth-child(3) {
        display: block;
        transform: scale(0.8) translateY(-70vw);
        margin-left: 43.031vw;
        margin-right: 44.115vw;
        transition: all 1s;
      }
      &:nth-child(4) {
        display: block;
        transform: scale(1) translateY(-62.9vw);
        margin-left: 10vw;
        transition: all 1s;
      }
      &:nth-child(5) {
        display: block;
        transform: scale(1) translateY(-98vw);
        margin-left: 69vw;
        transition: all 1s;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .thirdBarNews {
    position: relative;
    width: 100%;
    height: 149.87vw;
    background: var(--light);
    opacity: 1;
    .pills {
      position: absolute;
      width: 100%;
      height: 100%;
      .ellipse {
        position: absolute;
        width: 100%;
        height: 100%;
        &:nth-child(1) {
          width: 55vw;
          height: 55vw;
          top: -18vw;
          left: -20vw;
          transform: rotate(40deg);
        }
        &:nth-child(2) {
          width: 30vw;
          height: 30vw;
          top: 0;
          left: 80vw;
          transform: rotate(20deg);
        }
        &:nth-child(3) {
          width: 30vw;
          height: 30vw;
          top: 45vw;
          left: -12vw;
          transform: rotate(40deg);
        }
        &:nth-child(4) {
          width: 45vw;
          height: 45vw;
          top: 44vw;
          left: 30vw;
          transform: rotate(-70deg);
        }
        &:nth-child(5) {
          width: 40vw;
          height: 40vw;
          top: 90vw;
          left: 20vw;
          transform: rotate(-60deg);
        }
        &:nth-child(6) {
          opacity: 0;
        }
      }
      .ellipse2 {
        opacity: 0;
      }
      .ellipse3 {
        opacity: 0;
      }
    }
    .news {
      .newsBlog {
        position: absolute;
        .newsec {
          width: 35.026vw;
          .image-holder {
            width: 31.25vw;
            height: 31.25vw;
            .img {
              width: 29.427vw;
              height: 29.427vw;
              border-radius: 50%;
            }
          }
          .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 100%;
            h2 {
              font-size: 1.693vw;
              line-height: 2.344vw;
              font-weight: 400;
              color: var(--primary-t-color);
            }
            h1 {
              font-size: 2.083vw;
              line-height: 2.865vw;
              font-weight: 400;
              color: var(--primary-m-color);
            }
            h3 {
              font-size: 1.693vw;
              line-height: 2.344vw;
              font-weight: 300;
              color: var(--primary-b-color);
            }
          }
        }
        &:nth-child(1) {
          left: -5vw;
          top: -8vw;
          .newsec {
            .image-holder {
              width: 36.458vw;
              height: 36.458vw;
              .img {
                width: 34.635vw;
                height: 34.635vw;
              }
            }
          }
        }
        &:nth-child(2) {
          top: 12.891vw;
          left: 63.01vw;
          margin: 0;
        }
        &:nth-child(3) {
          top: 53.255vw;
          left: 2.948vw;
          transform: scale(1);
          margin: 0;
        }
        &:nth-child(4) {
          top: 62.5vw;
          left: 52.594vw;
          padding: 0;
          transform: scale(1);
          .image-holder {
            width: 56.12vw;
            height: 56.12vw;
            .img {
              width: 54.297vw;
              height: 54.297vw;
            }
          }
        }
        &:nth-child(5) {
          top: 102.865vw;
          left: 2vw;
          padding: 0;
          transform: scale(1);
          margin-left: 0;
          .image-holder {
            width: 28.646vw;
            height: 28.646vw;
            .img {
              width: 26.823vw;
              height: 26.823vw;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .thirdBarNews {
    position: relative;
    width: 100%;
    height: 338.933vw;
    background: var(--light);
    opacity: 1;
    .pills {
      position: absolute;
      width: 100%;
      height: 100%;
      .ellipse {
        position: absolute;
        width: 100%;
        height: 100%;
        &:nth-child(1) {
          width: 65.067vw;
          height: 65.067vw;
          top: -24vw;
          left: -30vw;
          transform: rotate(40deg);
        }
        &:nth-child(2) {
          width: 45vw;
          height: 45vw;
          top: 25.867vw;
          left: 70vw;
          transform: rotate(20deg);
        }
        &:nth-child(3) {
          width: 60vw;
          height: 60vw;
          top: 61.867vw;
          left: 5vw;
          transform: rotate(40deg);
        }
        &:nth-child(4) {
          width: 95vw;
          height: 95vw;
          top: 189.6vw;
          left: -30vw;
          transform: rotate(0deg);
        }
        &:nth-child(5) {
          width: 80vw;
          height: 80vw;
          top: 118.667vw;
          left: 40vw;
          transform: rotate(-60deg);
        }
        &:nth-child(6) {
          opacity: 0;
        }
      }
      .ellipse2 {
        opacity: 0;
      }
      .ellipse3 {
        opacity: 0;
      }
    }
    .news {
      .newsBlog {
        position: absolute;
        .newsec {
          width: 59.467vw;
          .image-holder {
            width: 42.667vw;
            height: 42.667vw;
            .img {
              width: 40vw;
              height: 40vw;
              border-radius: 50%;
            }
          }
          .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 100%;
            h2 {
              font-size: 2.667vw;
              line-height: 3.733vw;
              font-weight: 400;
              color: var(--primary-t-color);
            }
            h1 {
              font-size: 3.2vw;
              line-height: 4vw;
              font-weight: 400;
              color: var(--primary-m-color);
            }
            h3 {
              font-size: 2.667vw;
              line-height: 3.733vw;
              font-weight: 300;
              color: var(--primary-b-color);
            }
          }
        }
        &:nth-child(1) {
          top: -5vw;
          left: -15vw;
          .newsec {
            .image-holder {
              width: 42.667vw;
              height: 42.667vw;
              .img {
                width: 40vw;
                height: 40vw;
              }
            }
          }
        }
        &:nth-child(2) {
          top: 62.933vw;
          left: 34.667vw;
          margin: 0;
        }
        &:nth-child(3) {
          top: 130.667vw;
          left: 10.933vw;
          transform: scale(1);
          margin: 0;
          .image-holder {
            width: 50.667vw;
            height: 50.667vw;
            .img {
              width: 48vw;
              height: 48vw;
            }
          }
        }
        &:nth-child(4) {
          top: 204.533vw;
          left: 38.4vw;
          padding: 0;
          transform: scale(1);
        }
        &:nth-child(5) {
          top: 271.733vw;
          left: 2vw;
          padding: 0;
          transform: scale(1);
          .image-holder {
            width: 38.667vw;
            height: 38.667vw;
            .img {
              width: 36vw;
              height: 36vw;
            }
          }
        }
      }
    }
  }
}
</style>
